module.exports = __webpack_public_path__ + "media/images/common/icon-arrow-under-e963618f1d8a6f445193d62890da6c71.png";